export const loadExternalScript = async (id, url, callback = () => {}) => {
    const scriptExists = document.getElementById(id);

    if (!scriptExists) {
        const script = document.createElement('script');
        script.src = url;
        script.id = id;
        document.head.appendChild(script);

        return await new Promise((resolve) => {
            script.addEventListener('load', () => resolve(callback()));
        })
    } else {
        callback()
    }

    return true;
}
